// extracted by mini-css-extract-plugin
var _1 = "UserPasswordEditStep_text__bCLOO";
export { _1 as "text" }
